import React, { memo, ChangeEvent } from 'react'
import {
  ISpotPremium,
  ISpotBiddingRule,
  SPOT_PREMIUM_TYPE,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TextInput } from 'components/atoms'

interface IPremiumProps {
  value?: RecursivePartial<ISpotPremium>
  onChange(value: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const Premium = memo<IPremiumProps>(({ error, onChange, value: spotPremium }) => {
  const { amount } = spotPremium || {}
  const label =
    spotPremium?.premiumType === SPOT_PREMIUM_TYPE.percentage ? '% Premium' : 'Total Dollars'
  const placeholder =
    spotPremium?.premiumType === SPOT_PREMIUM_TYPE.percentage
      ? 'Enter premium percentage'
      : 'Enter total dollar premium'
  const premiumHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    if (Number(value) && spotPremium?.premiumType === SPOT_PREMIUM_TYPE.percentage) {
      onChange({
        spotPremium: {
          ...spotPremium,
          amount: `${Number(value) / 100}`,
        },
      })
    } else {
      // prevent the frontend from converting valid numerical symbols to NaN before the
      // user finishes inputting them
      if (['.', '-', '-.', '-0', '-0.'].includes(value)) {
        value = ''
      }
      onChange({
        spotPremium: {
          ...spotPremium,
          amount: `${value}`,
        },
      })
    }
  }
  const dollarTotalPremium = amount
  const premiumPercentageValue = amount ? `${Number((Number(amount) * 100).toFixed(1))}` : ''
  const premiumValue =
    spotPremium?.premiumType === SPOT_PREMIUM_TYPE.percentage
      ? premiumPercentageValue
      : dollarTotalPremium

  return (
    <div className='col-md-6 col-xs-4'>
      <TextInput
        label={label}
        placeholder={placeholder}
        id='modal-premium'
        dataTest='modal-premium'
        value={premiumValue}
        onChange={premiumHandler}
        large
        validationMessage={error}
        invalid={!!error}
      />
    </div>
  )
})
